const Footer = () => {
    return (
      <footer>
          <p>
            created by <a
              href="https://github.com/bluedeepart"
              target="_blank"
              rel="noopener noreferrer"
            >
              bluedeepart
            </a>
            - devChallenges.io
          </p>
      </footer>
    );
  };
  
  export default Footer;
  